export default __webpack_public_path__ + "mediatavern.b41f62e.jpeg";